/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoTextAreaDynamic implements angular.IDirective {
    private filter: angular.IFilterService;
    restrict = "E";
    scope = {
      name: "@",
      currentValue: "=ngModel",
      contentKey: "@",
      disabled: "=ngDisabled",
      required: "=ngRequired",
      lenMaxOne: "=?",
      lenMaxTwo: "=?",
      autofocus: "=?",
      filterChar: "=?",
      limitExceededMsg: "@"
    };

      template = " <style> .red_border_invalid { border:1px solid #f00;} textarea#dynamic-text-area { min-height:100px;}</style><div><div class=\"meevo_input_wrapper\"><label translate=\"{{::contentKey}}\"></label><div ng-class=\"{'ng-dirty required_red_bubble ' : required}\"></div></div><div><div style=\"color:red;text-align: right;\" ng-if=\"currentValue.length>500\">The text exceeds the limit allowed</div><div style=\"color:Red;\" ng-if=\"countLeft<0 && currentValue.length<=500\"><label style=\"color:Red;\" translate=\"{{::limitExceededMsg || 'Text messages containing more than 160 characters may be split into two or more text messages when received.'}}\"></label></div><textarea id=\"dynamic-text-area\" ng-hide=\"!disabled\" ng-focus=\"autofocus\" ng-class=\"{' red_border_invalid' : (!currentValue && required) || countLeft<0}\" name=\"{{name}}\"  maxlength=\"500\"  ng-model=\"currentValue\" ng-disabled=\"disabled\" ng-required=\"required\"></textarea></div><span layout=\"row\" layout-align=\"end center \" ng-if=\"lenMaxTwo \">{{countLeft}} Characters Left</span>";

    constructor(private $compile: angular.ICompileService) {

    }

    link = (scope: any, element: JQuery, attrs: angular.IAttributes, formCtrl: angular.IFormController) => {
        var ele = angular.element(element).find('textarea');
        if (scope.autofocus) {
            window.setTimeout(function () {
                console.log(ele);
                ele.focus();
            }, 250);
        }
        if (!scope.lenMaxTwo) {
            scope.lenMaxTwo = '';
        }
        if (!scope.currentValue) {
            scope.countLeft = scope.lenMaxTwo;
        } else {
            if (scope.currentValue.match(scope.filterChar) && scope.lenMaxOne >= 0) {
                scope.countLeft = scope.lenMaxOne - scope.currentValue.length;
                scope.maxLength = scope.lenMaxOne;
            }
            else {
                scope.countLeft = scope.lenMaxTwo - scope.currentValue.length;
                scope.maxLength = scope.lenMaxTwo;
            }
        }

        scope.$watch('currentValue',
            currentValue => {
                if (scope.currentValue != null && scope.currentValue.match(scope.filterChar) && scope.lenMaxOne >= 0) {
                    scope.countLeft = scope.lenMaxOne - scope.currentValue.length;
                    scope.maxLength = scope.lenMaxOne;
                }
                else {
                    if (scope.currentValue != null)
                        scope.countLeft = scope.lenMaxTwo - scope.currentValue.length;
                    else {
                        scope.countLeft = scope.lenMaxTwo;
                    }
                    scope.maxLength = scope.lenMaxTwo;
                }
            });
      element.on("click", (event: JQueryEventObject) => {
        if (!scope.isDisabled) {
          let target: any = event.target || event.srcElement;
          if (target.id === scope.id) {
            target.select();
          }
          event.preventDefault();
        }
      });
    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($compile) => {
          return new MeevoTextAreaDynamic($compile);
      };

      directive.$inject = ["$compile"];

      return directive;
    }
  }

  angular.module("meevo.components.controls")
      .directive("meevoTextAreaDynamic", MeevoTextAreaDynamic.factory());
}
